import BouncingSpinner from 'components/BouncingSpinner';
import SearchInput from 'components/inputs/SearchInput';
import { Button } from 'components/lib';
import SubmittalsFilterPopover from 'components/SubmittalsFilterPopover';
import React, { useEffect } from 'react';
import { Project } from 'records/Project';
import { SubmittalListTypes } from 'records/Submittal';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import ExportButton from '../ExportButton';

interface Props extends WithAppStoreProps {
  onAddSubmittal: () => void;
  onUploadSubmittalLog: () => void;
  uploadingSubmittalLog: boolean;
}

const SubmittalLogTabSubHeader = (props: Props) => {
  useEffect(() => {
    return () => {
      props.actions.clearInteractions();
    };
  }, []);

  const handleSearchChange = (searchString: string): void => {
    const { appState, actions } = props;
    const { submittalQuery } = appState;
    const nextSubQuery = submittalQuery.set('search', searchString);
    actions.setSubmittalQuery(nextSubQuery);
  };

  const {
    appState,
    onAddSubmittal,
    onUploadSubmittalLog,
    uploadingSubmittalLog,
  } = props;
  const { submittals, queriedSubmittals, projects, selectedProject } = appState;
  const { permissions, Status } = projects.get(selectedProject, new Project());

  const projectClosed = Status === 'Closed' || Status === 'Trial Expired';
  const { translate } = useTranslator(['buttons', 'submittalsPage']);

  return (
    <div id="sub-log-tab-subheader">
      <div className="column mx4">
        <div className="hs2 my4 row items-center justify-between">
          <div className="mr4 font-size-5 medium color-gray-9">
            {queriedSubmittals.size !== submittals.size
              ? `${translate('submittalsPage:results')} (${
                  queriedSubmittals.size
                })`
              : `${translate('submittalsPage:allSubmittals')} (${
                  submittals.size
                })`}
          </div>
          <div className="row">
            <ExportButton
              id="sub-log-tab-subheader-export-btn"
              listType={SubmittalListTypes.ALL}
            />
            <SubmittalsFilterPopover />
            <SearchInput
              id="sub-log-tab-subheader-search"
              placeholder={translate('buttons:search')}
              onChange={handleSearchChange}
            />
            {permissions.createSubmittal ? (
              <div className="ml4">
                <Button
                  disabled={projectClosed}
                  id="sub-log-tab-subheader-add-btn"
                  onClick={onAddSubmittal}
                  size="small"
                  variant="secondary"
                >
                  {translate('buttons:add')}
                </Button>
              </div>
            ) : null}
            <div>
              {submittals.size === 0 ? (
                <div className="ml3 pos-r">
                  {uploadingSubmittalLog ? (
                    <div className="pos-a hs2 flex-center w100">
                      <BouncingSpinner />
                    </div>
                  ) : null}
                  <Button
                    disabled={projectClosed}
                    id="sub-log-tab-subheader-upload-btn"
                    onClick={onUploadSubmittalLog}
                    size="small"
                    style={{
                      visibility: uploadingSubmittalLog ? 'hidden' : 'visible',
                    }}
                    variant="primary"
                  >
                    {translate('buttons:upload')}
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAppStore<Props>(SubmittalLogTabSubHeader);
